import { createReducer } from '@reduxjs/toolkit';

import { OBSERVE_DETECTING_AUTHENTICATED_USER } from 'constants/redux-actions';

const initState = {};

const detectingAuthenticatedUserReducer = createReducer(initState, {
  [OBSERVE_DETECTING_AUTHENTICATED_USER]: (_, action) => ({ show: action.payload }),
});

export default detectingAuthenticatedUserReducer;
